/** @format */

import React, { useContext } from "react";
import { reversalDataArray, statusDataArray,adminDataArray } from "./Fields";
import { FinancialDocContext } from "../Contex";
import { FieldsReducer } from "./../../../../CommonComponents/Reducer/Index";

export default function AdminTab(props) {
  const { onChange, operation, dropDowns, _financialDocData } =
    useContext(FinancialDocContext);

  const mergedFieldData = (field) => {
    let newFieldObject = { ...field, dataSource: _financialDocData, onChange };
    switch (operation) {
      case "Display":
        newFieldObject.disabled = true;
        break;
      case "Change":
        if (newFieldObject.key) {
          newFieldObject.disabled = true;
        }
        if (newFieldObject.displayOnly) {
          newFieldObject.disabled = true;
        }
        break;
      case "Create":
        if (newFieldObject.displayOnly) {
          newFieldObject.disabled = true;
        }
        break;
      default:
    }

    return newFieldObject;
  };
  const fieldsState = {
    dropDowns,
  };
  
  const reversalDataArrayFieldsToRender  = reversalDataArray(fieldsState);
  const adminDataArrayFieldsToRender     = adminDataArray(fieldsState);
  const statusDataArrayFieldsToRender    = statusDataArray(fieldsState);

  return (
    <div className="row">
      <div className="col-lg-3 col-sm-6 col-xs-12">
        <div className="card">
          <div className="cardHeader">
            <h2>Reversal</h2>
          </div>
          <div className="cardBody">
            {reversalDataArrayFieldsToRender.map((field, index) => (
              <FieldsReducer field={mergedFieldData(field)} key={index} />
            ))}
          </div>
        </div>
      </div>  
      <div className="col-lg-3 col-sm-6 col-xs-12">
        <div className="card">
          <div className="cardHeader">
            <h2>Status</h2>
          </div>
          <div className="cardBody">
            {statusDataArrayFieldsToRender.map((field, index) => (
              <FieldsReducer field={mergedFieldData(field)} key={index} />
            ))}
          </div>
        </div>
      </div> 
      <div className="col-lg-3 col-sm-6 col-xs-12">
        <div className="card">
          <div className="cardHeader">
            <h2>Admin</h2>
          </div>
          <div className="cardBody">
            {adminDataArrayFieldsToRender.map((field, index) => (
              <FieldsReducer field={mergedFieldData(field)} key={index} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
